export default {
  TYPE: {
    REQUEST: 1,
    CHRONIC_CONDITION: 2,
    ROSTER_UPDATE: 3,
    RECENTLY_ACQUIRED_PLAYER: 4,
    MLB_CLUB_MEDICAL_OBJECTION: 5,
    PLAYER_INTEREST: 6,
    BOC_AUTOMATED_NOTIFICATIONS: 7
  },
  ID: {
    1: "REQUEST",
    2: "CHRONIC_CONDITION",
    3: "ROSTER_UPDATE",
    4: "RECENTLY_ACQUIRED_PLAYER",
    5: "MLB_CLUB_MEDICAL_OBJECTION",
    6: "PLAYER_INTEREST",
    7: "BOC_AUTOMATED_NOTIFICATIONS"
  },
  NAMES: {
    1: "Request",
    2: "Chronic Condition",
    3: "Roster Update",
    4: "Recently-Acquired Player",
    5: "MLB Club Medical Objection",
    6: "Player Interest",
    7: "BOC Automated Notifications"
  }
};
